export type Severity = 'High' | 'Med' | 'Low';

export type Action = 'Must edit' | 'Edit candidate' | 'Leave & defend' | 'Note only';

export type Source = 'Student Edition' | 'Interactive Student Notebook' | 'Enhancing Learning';

export interface Finding {
  action: Action;
  category: string;
  flagged_text: string;
  is_asset: boolean;
  lens: string;
  location: string;
  notes: string;
  section_title: string;
  severity: Severity;
  source: Source;
  standards_driven: string;
  suggestion: string;
}

export interface AuditReport {
  findings: Finding[];
  lesson_title: string;
  rubric: string;
  rubric_name: string;
  summary: {
    asset_count: number;
    by_action: Record<string, number>;
    by_severity: Record<Severity, number>;
    risk_count: number;
    total_findings: number;
  };
}

export type AuditStatus = 'idle' | 'running' | 'completed' | 'failed' | 'rate_limited';

export interface LessonAuditSummary {
  generated_at?: string;
  has_report: boolean;
  lesson_id: number;
  lesson_number?: string | null;
  must_edit?: number | null;
  risk_count?: number | null;
  title: string;
  unit_title?: string | null;
}

export interface MaterialAuditSummary {
  auditable?: boolean;
  generated_at?: string | null;
  has_report: boolean;
  must_edit?: number | null;
  reference_material_id: number;
  risk_count?: number | null;
  title: string;
}

export interface LibraryOption {
  label: string;
  tag: string;
}

// AIDEV-TODO: the content audit still picks its libraries from this hardcoded list; tags must stay in
// the backend's AUDITED_LIBRARY_TAGS whitelist. Assign/grade went data-driven in PLAT-14851 — this
// could read the Library tags the same way instead of needing a code change per library.
export const LIBRARIES: LibraryOption[] = [
  { label: 'Biography Library', tag: 'Biographies' },
  { label: 'Civics Library', tag: 'Civics Library' },
  { label: 'Economics Library', tag: 'Economics Library' },
  { label: 'Map Library', tag: 'Maps' },
  { label: 'Primary Source Library', tag: 'Primary Source Library' },
  { label: 'Supreme Court Case Library', tag: 'Supreme Court Cases' },
];

export const lessonLabel = (lesson: LessonAuditSummary): string => (
  lesson.lesson_number ? `Lesson ${lesson.lesson_number} - ${lesson.title}` : lesson.title
);
